module.exports = __webpack_public_path__ + "media/eclipsecross.05e2d740.mp4";